module.exports = __webpack_public_path__ + "static/media/un.bdaf37f9.svg";